import { render, staticRenderFns } from "./SearchServiceOrdersPage.vue?vue&type=template&id=338b5526&scoped=true&"
import script from "./SearchServiceOrdersPage.vue?vue&type=script&lang=js&"
export * from "./SearchServiceOrdersPage.vue?vue&type=script&lang=js&"
import style0 from "./SearchServiceOrdersPage.vue?vue&type=style&index=0&id=338b5526&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "338b5526",
  null
  
)

export default component.exports